import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
// Initialize Meta Pixel and track PageView
initMetaPixel();
trackPageView();
render(<App data-id="element-204" />, document.getElementById('root'));